import { render, staticRenderFns } from "./HowWorksInBody.vue?vue&type=template&id=207cb2a2&"
import script from "./HowWorksInBody.vue?vue&type=script&lang=js&"
export * from "./HowWorksInBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports